import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatSelectionList } from '@angular/material/list';
import { ColumnDescription } from '../../../models/user-report-filter.model';

@Component({
  selector: 'app-column-selector',
  templateUrl: './column-selector.component.html',
  styleUrls: ['./column-selector.component.scss']
})
export class ColumnSelectorComponent implements OnInit, OnChanges {
  @ViewChild('source') sourceColumn: MatSelectionList;
  @ViewChild('destination') destinationColumn: MatSelectionList;

  @Input()
  public originalDisplayedColumns: Array<ColumnDescription>;

  @Input()
  public selectedDisplayedColumns: Array<ColumnDescription>;

  @Output()
  public selectedDisplayedColumnsEmitter = new EventEmitter<Array<ColumnDescription>>();

  public sourceColumns = new Array<filterColumn>();
  public visibleSourceColumns = new Array<filterColumn>();
  public selectedColumns = new Array<filterColumn>();

  public isSourceColumnSelected(value: filterColumn): boolean {
    return this.sourceColumn ? this.sourceColumn.selectedOptions.selected.findIndex(o => o.value.headertxt === value.headertxt) !== -1 : false;
  }

  public isDestinationColumnSelected(value: filterColumn): boolean {
    return this.destinationColumn ? this.destinationColumn.selectedOptions.selected.findIndex(o => o.value.headertxt === value.headertxt) !== -1 : false;
  }

  public get hideMoveSingleOver(): boolean {
    return this.sourceColumn ? this.sourceColumn.selectedOptions.selected.length !== 1 : false;
  }

  public get hideMoveSingleBack(): boolean {
    return this.destinationColumn ? this.destinationColumn.selectedOptions.selected.length !== 1 : false;
  }

  public get hideMoveMultipleOver(): boolean {
    return this.sourceColumn ? this.sourceColumn.selectedOptions.selected.length < 2 : false;
  }

  public get hideMoveMultipleBack(): boolean {
    return this.destinationColumn ? this.destinationColumn.selectedOptions.selected.length < 2 : false;
  }

  public get visibleColumns(): filterColumn[] {
    return this.sourceColumns.filter(x => x.visible);
  }

  public constructor() { }

  public ngOnChanges(changes: SimpleChanges) {
    const originalColumns = changes["originalDisplayedColumns"];
    const selectedCols = changes["selectedDisplayedColumns"];

    if (originalColumns) {
      this.originalDisplayedColumns = originalColumns.currentValue;

      this.sourceColumns = new Array<filterColumn>();

      this.originalDisplayedColumns.forEach((x, index) => {
        this.sourceColumns.push({ columnfield: x.columnfield, headertxt: x.headertxt, order: index, visible: true });
      })
    }

    if (selectedCols) {
      this.selectedDisplayedColumns = selectedCols.currentValue;

      this.selectedColumns = new Array<filterColumn>();

      this.selectedDisplayedColumns.forEach((x, index) => {
        this.selectedColumns.push({ columnfield: x.columnfield, headertxt: x.headertxt, order: index, visible: true });
      })

      this.sourceColumns.map(y => y.visible = this.selectedDisplayedColumns.findIndex(x => x.headertxt === y.headertxt) === -1);
    }
  }

  public ngOnInit(): void {
  }

  public moveOver(): void {
    if (this.sourceColumn.selectedOptions.selected.length === 0)
      return;

    const selected = this.sourceColumn.selectedOptions.selected.map(o => o.value);

    selected.forEach(x => this.selectedColumns.push(x));

    this.sourceColumns.map(x => {
      if (selected.map(x => x.headertxt).indexOf(x.headertxt) !== -1) {
        x.visible = false;
      }
    });

    this.reorderDestinationColumn();
  }

  public dblClickMoveOver(column: filterColumn): void {
    this.selectedColumns.push(column);

    this.sourceColumns.find(x => x === column).visible = false;

    this.reorderDestinationColumn();
  }

  public dblClickMoveBack(column: filterColumn): void {
    this.selectedColumns = this.selectedColumns.filter(x => x.headertxt !== column.headertxt);

    this.sourceColumns.find(x => x.headertxt === column.headertxt).visible = true;

    this.reorderDestinationColumn();
  }

  public moveBack(): void {
    if (this.destinationColumn.selectedOptions.selected.length === 0)
      return;

    const selected = this.destinationColumn.selectedOptions.selected.map(o => o.value);

    this.selectedColumns = this.selectedColumns.filter(x => selected.map(x => x.headertxt).indexOf(x.headertxt) === -1);

    this.sourceColumns.map(x => {
      if (selected.map(x => x.headertxt).indexOf(x.headertxt) !== -1) {
        x.visible = true;
      }
    });

    this.reorderDestinationColumn();
  }

  public refresh(): void {
    if (this.destinationColumn.options.length === 0)
      return;

    const selected = this.destinationColumn.options.map(x => x.value);

    this.selectedColumns = this.selectedColumns.filter(x => selected.map(x => x.headertxt).indexOf(x.headertxt) === -1);

    this.sourceColumns.map(x => {
      if (selected.map(x => x.headertxt).indexOf(x.headertxt) !== -1) {
        x.visible = true;
      }
    })

    this.reorderDestinationColumn();
  }

  public moveUp(): void {
    if (this.destinationColumn.selectedOptions.selected.length !== 1)
      return;

    const selected = this.destinationColumn.selectedOptions.selected.map(x => x.value)[0] as filterColumn;

    if (selected.order === 0)
      return;

    this.selectedColumns = this.selectedColumns.filter(x => selected !== x);

    this.selectedColumns.splice(selected.order - 1, 0, selected);

    this.reorderDestinationColumn();
  }

  public moveDown(): void {
    if (this.destinationColumn.selectedOptions.selected.length !== 1)
      return;

    const selected = this.destinationColumn.selectedOptions.selected.map(x => x.value)[0] as filterColumn;

    this.selectedColumns = this.selectedColumns.filter(x => selected !== x);

    this.selectedColumns.splice(selected.order + 1, 0, selected);

    this.reorderDestinationColumn();
  }

  private reorderDestinationColumn() {
    if (this.selectedColumns.length === 0)
      this.selectedDisplayedColumnsEmitter.emit(new Array<ColumnDescription>());

    this.selectedColumns.map((x, index) => {
      x.order = index;
    });

    const selectedColumn = this.selectedColumns.map(x => new ColumnDescription(x.columnfield, x.headertxt));
    this.selectedDisplayedColumnsEmitter.emit(selectedColumn);
  }
}

export class filterColumn {
  columnfield: string;
  headertxt: string;
  order: number;
  visible: boolean;
}
